import styles from './NoSidebarLayout.module.scss';

interface ComponentProps {
  children: React.ReactNode;
}

export const NoSidebarLayout = ({ children }: ComponentProps) => {
  return <main className={styles.main}>{children}</main>;
};
